// client/src/utils/staleChunkReload.js
import { getLogger } from "@/utils/logger";

const log = getLogger("staleChunkReload");

const RELOAD_GUARD_KEY = "landivo:staleChunkReloadAt";
// Only auto-reload once per window. If the chunk is still missing after a
// fresh reload, the failure is not a stale deploy and reloading again would loop.
const RELOAD_GUARD_WINDOW_MS = 60_000;

const STALE_CHUNK_PATTERNS = [
  /failed to fetch dynamically imported module/i, // Chrome/Edge
  /error loading dynamically imported module/i, // Firefox
  /importing a module script failed/i, // Safari
  /unable to preload css/i, // Vite CSS preload failure
];

export const isStaleChunkError = (error) => {
  const message = error?.message || String(error || "");
  return STALE_CHUNK_PATTERNS.some((pattern) => pattern.test(message));
};

export const reloadForStaleChunk = (source) => {
  const now = Date.now();
  let lastReloadAt;
  try {
    lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY)) || 0;
  } catch (storageError) {
    // Without storage the guard cannot persist across reloads, so skip the
    // automatic reload entirely rather than risk a reload loop.
    log.warn(
      `[staleChunkReload:reloadForStaleChunk] > [Request]: source=${source} > [Response]: skipped > [Comment]: sessionStorage unavailable ${storageError?.message || ""}`
    );
    return false;
  }

  if (now - lastReloadAt < RELOAD_GUARD_WINDOW_MS) {
    log.warn(
      `[staleChunkReload:reloadForStaleChunk] > [Request]: source=${source} > [Response]: skipped > [Comment]: reload already attempted ${now - lastReloadAt}ms ago`
    );
    return false;
  }

  try {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
  } catch {
    return false;
  }

  log.warn(
    `[staleChunkReload:reloadForStaleChunk] > [Request]: source=${source} > [Response]: reloading > [Comment]: stale build chunk detected, fetching latest deploy`
  );
  window.location.reload();
  return true;
};
